import {WindowRef} from '../../providers/window';
import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private window: WindowRef) {this.window.nativeWindow.mixpanel.track("Home: Page start")}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /home/manu/ArtCode/artCode/artCode/src/app/pages/home/home.component.ts